import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-cream/10 bg-ink-950 pb-28 pt-12 sm:pb-14" data-id="element-101" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-5 text-center" data-id="element-102" data-mp="3ggtymjf7hl5r">
        <p className="font-display text-lg uppercase tracking-[0.18em] text-gold-500" data-id="element-103" data-mp="32p5m4f11ouo9">
          Método Glúteos 360™
        </p>
        <p className="max-w-2xl text-xs leading-relaxed text-cream/45" data-id="element-104" data-mp="36nd6djupwe47">
          Producto 100% digital. Los resultados pueden variar según el compromiso, la constancia y
          las condiciones de salud de cada persona. Este material es informativo y no reemplaza el
          consejo médico profesional.
        </p>
        <p className="text-xs text-cream/35" data-id="element-105" data-mp="3qdf2h1fhoq80">
          © {new Date().getFullYear()} Método Glúteos 360™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}